// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 678 ? "component---src-pages-index-js" : chunkId) + "-" + {"678":"779cd8f36546ef56d1c0","731":"50a6dabafe7d779dd9de","843":"4d22e4d87d98fa226c97"}[chunkId] + ".js";
};